var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showButton)?_c('b-button',{staticClass:"float-right",attrs:{"size":"lg","type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.submitText))]):_vm._e(),(
      _vm.showButton &&
        _vm.reviewInfo.reviewer_role === 'OFDIT lead' &&
        _vm.reviewInfo.status === 'Reviews submitted'
    )?_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":_vm.releaseToAd}},[_vm._v("Release to AD only")]):_c('b-alert',{attrs:{"show":!_vm.showButton,"variant":"info"}},[_vm._v(_vm._s(_vm.submitText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }